import { useState, useMemo } from "react";
import { getMergedFriendIds } from "../utils/similarity";
import "./RecentBooksScreen.css";

const RecentBooksScreen = ({ allBooks = [], users = [], currentUser, autoFriends = [], myFriends = [], onBack, onBookClick }) => {
  const [friendFilter, setFriendFilter] = useState(false);
  const now = new Date();
  const weekAgo = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 7);

  const ownedBookIds = new Set((users || []).flatMap(u => u.bookIds || []));

  const friendIds = useMemo(
    () => getMergedFriendIds(autoFriends, myFriends, users, currentUser?.uid),
    [autoFriends, myFriends, users, currentUser]
  );

  const recentBooks = allBooks
    .filter(b => {
      if (!ownedBookIds.has(b.id)) return false;
      if (!b.addedDate) return false;
      const [y, m, d] = b.addedDate.split(".").map(Number);
      return new Date(y, m - 1, d) >= weekAgo;
    })
    .sort((a, b) => (b.addedDate || "").localeCompare(a.addedDate || ""));

  const displayBooks = friendFilter
    ? recentBooks.filter(b => {
        const bookOwners = (users || []).filter(u => (u.bookIds || []).includes(b.id));
        return bookOwners.some(u => friendIds.has(u.id));
      })
    : recentBooks;

  const getOwners = (book) => {
    return (users || [])
      .filter(u => (u.bookIds || []).includes(book.id))
      .map(u => ({ name: u.name, isFriend: friendIds.has(u.id) }))
      .slice(0, 3);
  };

  const hasFriends = friendIds.size > 0;

  return (
    <div className="bp-layer bp-layer-full">
      <div className="back-bar" onClick={onBack}>← <span>돌아가기</span></div>

      <div className="recent-header">
        <div className="recent-title">🔥 최근 7일 등록된 책</div>
        <div className="recent-sub">{recentBooks.length}권의 새로운 책이 등록되었어요</div>
      </div>

      {hasFriends && (
        <div className="recent-filters">
          <button
            className={`recent-filter-btn${!friendFilter ? " active" : ""}`}
            onClick={() => setFriendFilter(false)}
          >
            전체
          </button>
          <button
            className={`recent-filter-btn${friendFilter ? " active" : ""}`}
            onClick={() => setFriendFilter(true)}
          >
            🤝 이웃 행성
          </button>
        </div>
      )}

      <div className="recent-list">
        {displayBooks.length === 0 ? (
          <div className="recent-empty">
            {friendFilter ? "이웃 행성이 등록한 책이 없어요" : "최근 7일간 등록된 책이 없어요"}
          </div>
        ) : (
          displayBooks.map((b, i) => {
            const owners = getOwners(b);
            const totalOwners = (users || []).filter(u => (u.bookIds || []).includes(b.id)).length;
            return (
              <div
                key={b.id}
                className="recent-item"
                style={{ animationDelay: `${i * 0.06}s` }}
                onClick={() => onBookClick(b.id)}
              >
                <div className="recent-cover" style={{ background: b.bg || "#1a1a2e" }}>
                  {b.cover
                    ? <img src={b.cover} alt={b.title} />
                    : <span>{b.emoji || "📖"}</span>
                  }
                </div>
                <div className="recent-info">
                  <div className="recent-book-title">{b.title}</div>
                  <div className="recent-book-author">{b.author}</div>
                  <div className="recent-book-meta">
                    <span className="recent-date">📅 {b.addedDate} 등록</span>
                    <span className="recent-genre">{b.genre}</span>
                  </div>
                  {owners.length > 0 && (
                    <div className="recent-owners">
                      {owners.map((o, j) => (
                        <span key={j}>
                          {j > 0 && ", "}
                          <span className={o.isFriend ? "recent-owner-friend" : ""}>{o.name}</span>
                        </span>
                      ))}
                      {totalOwners > owners.length && " 외"}
                    </div>
                  )}
                </div>
              </div>
            );
          })
        )}
      </div>
    </div>
  );
};

export default RecentBooksScreen;
